import { render, staticRenderFns } from "./explanations.vue?vue&type=template&id=126638a6&scoped=true"
import script from "./explanations.vue?vue&type=script&lang=js"
export * from "./explanations.vue?vue&type=script&lang=js"
import style0 from "./explanations.vue?vue&type=style&index=0&id=126638a6&prod&lang=scss&scoped=true"
import style1 from "./explanations.vue?vue&type=style&index=1&id=126638a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126638a6",
  null
  
)

export default component.exports